import { useTranslation } from 'react-i18next';
import { Box, Button, TextField } from '@mui/material';
import { DetailSection } from './DetailSection';

const primaryButtonSx = { alignSelf: { xs: 'stretch', sm: 'flex-start' } };

export function OrganizationDetailsForm({ form, onChange, onSave, isSaving }) {
  const { t } = useTranslation();

  return (
    <DetailSection title={t('organizations.details')}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label={t('organizations.name')}
          value={form.name}
          onChange={(e) => onChange({ ...form, name: e.target.value })}
          fullWidth
          size="small"
        />
        <TextField
          label={t('organizations.nickname')}
          value={form.nickname}
          onChange={(e) => onChange({ ...form, nickname: e.target.value })}
          fullWidth
          size="small"
        />
        <TextField
          label={t('organizations.billingEmail')}
          value={form.billingEmail}
          onChange={(e) => onChange({ ...form, billingEmail: e.target.value })}
          fullWidth
          size="small"
          type="email"
          inputMode="email"
        />
        <TextField
          label={t('organizations.taxId')}
          value={form.taxId}
          onChange={(e) => onChange({ ...form, taxId: e.target.value })}
          fullWidth
          size="small"
        />
        <Button variant="contained" onClick={onSave} disabled={isSaving} sx={primaryButtonSx}>
          {t('organizations.save')}
        </Button>
      </Box>
    </DetailSection>
  );
}
